export default "__VITE_ASSET__D09aQ5zI__"